import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Midjourney advanced techniques" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">Midjourney</h2>

        <div className="grid grid-cols-2 gap-12 mt-8">
          <div>
            <h3 className="text-2xl font-semibold mb-4">Waarom Midjourney</h3>
            <div className="space-y-2">
              <p>• Meest 'kunstzinnig'</p>
              <p>• Snel</p>
              <p>• Input voor andere tools als ChatGPT en Sora</p>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-4">Features</h3>
            <div className="space-y-2">
              <p>• Edit mode</p>
              <p>• Omni reference</p>
              <p>• Char reference</p>
              <p>• Draft mode</p>
              <p>• Style params</p>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};
